// src/main.ts

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { Amplify } from 'aws-amplify';

// Configuração do AWS Amplify
Amplify.configure({
  Auth: {
    region: environment.cognito.cognitoRegion,
    userPoolId: environment.cognito.cognitoUserPollId,
    userPoolWebClientId: environment.cognito.cognitoClientId,
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));